export default __webpack_public_path__ + "static/media/competitive-landscape.png";